export default "__VITE_ASSET__3fec8f8c__"